import { render, staticRenderFns } from "./fa_avatar.vue?vue&type=template&id=1d4d87cb&scoped=true&"
import script from "./fa_avatar.vue?vue&type=script&lang=js&"
export * from "./fa_avatar.vue?vue&type=script&lang=js&"
import style0 from "./fa_avatar.vue?vue&type=style&index=0&id=1d4d87cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4d87cb",
  null
  
)

export default component.exports